import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { AppContext } from "../../contexts/AppContext";

export default function ProjectScreeningQueAns({
  expert_id,
  project_id,
  screeningQuestions,
  data,
  backupData,
  setBackupData,
}) {
  const { API_URL } = useContext(UrlContext);
  const { queAnswers, setQueAnswers } = useContext(AppContext);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const [selectedChoices, setSelectedChoices] = useState({});
  const [hasResponses, setHasResponses] = useState(false);

  // useEffect(() => {
  //   setQueAnswers(screeningQuestions);
  // }, [screeningQuestions]);

  // useEffect(() => {
  //   if (showEditPopup) {
  //     queAnswers.map((row, index) => {
  //       if (row.answerType === "Confidence Level") {
  //         // Find the button with the specific value "xyz"
  //         const button = document.querySelector(
  //           `input[type="radio"][value="${row.answer}"]`
  //         );

  //         if (button) {
  //           // Apply desired changes, such as selecting or styling the button
  //           button.checked = true; // If you want to select it
  //           button.parentElement.style.borderColor = "#1a73e8"; // Change border color
  //           button.parentElement.style.color = "#1a73e8"; // Change text color
  //         }
  //       }
  //     });
  //   }
  // }, [showEditPopup]);

  const handleOpenPopup = () => {
    setFetchingData(true);
    const url = `${API_URL}fetch-question-answers`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ projID: project_id, expertID: expert_id }),
    })
      .then((res) => res.json())
      .then((data) => {
        setFetchingData(false);
        if (data.status === "success") {
          const updatedChoices = data.screenQuestions.reduce((acc, row) => {
            if (row.answerType === "Matrix") {
              console.log(row.answer);
              return { ...acc, ...row.answer };
            }
            return acc;
          }, {});
        
          setSelectedChoices((prevChoices) => ({
            ...prevChoices,
            ...updatedChoices,
          }));
        
          setQueAnswers(data.screenQuestions);
          setShowEditPopup(true);

          // if (data.responses) {
          //   queAnswers.map((row, index) => {
          //     const toUpdate = data.responses.find(
          //       (item) => item.questionID === row.questionID
          //     );
          //     if (toUpdate) {
          //       if (row.answerType === "Matrix") {
          //         row.answer = toUpdate.answer;

          //         setSelectedChoices((prevChoices) => ({
          //           ...prevChoices, // Keep existing state
          //           ...toUpdate.answer, // Add or overwrite with new values
          //         }));
          //       } else {
          //         row.answer = toUpdate.answer;
          //       }
          //     } else {
          //       row.answer = "";
          //     }
          //   });
          //   setShowEditPopup(true);
          // } else {
          //   screeningQuestions.map((row, index) => {
          //     const res = [...queAnswers];
          //     const toUpdate = res.find(
          //       (item) => item.questionID === row.questionID
          //     );
          //     toUpdate.answer = "";
          //     setQueAnswers(res);
          //   });
          //   setShowEditPopup(true);
          // }
        } else {
          setFetchingData(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        setFetchingData(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong here!",
        });
      });
  };

  const handleSelectionChange = (questionIndex, choiceIndex, index) => {
    console.log(questionIndex, choiceIndex, index, queAnswers);
    // Update the selectedChoices state
    setSelectedChoices((prevChoices) => {
      const updatedChoices = {
        ...prevChoices,
        [index]: {
          ...prevChoices[index], // Ensure index exists
          [questionIndex]: {
            ...prevChoices[index]?.[questionIndex], // Ensure qIndex exists
            choice: choiceIndex,
          },
        },
      };

      const keyValue = Object.entries(updatedChoices).find(([key]) => Number(key) === index);
      if (keyValue) {
        const result = { [keyValue[0]]: keyValue[1] };
        // Call handleAnswerChange to store the updated choices in the answer field
        handleAnswerChange(index, { answer: JSON.stringify(result) });
      } else {
        console.log('Key not found');
      }

      return updatedChoices; // Return the updated choices
    });
  };

  // Handle reasoning (textarea input)
  const handleReasonChange = (questionIndex, response, index) => {
    // Update the selectedChoices state
    setSelectedChoices((prevChoices) => {
      const updatedChoices = {
        ...prevChoices,
        [index]: {
          ...prevChoices[index], // Ensure index exists
          [questionIndex]: {
            ...prevChoices[index]?.[questionIndex], // Ensure qIndex exists
            reason: response,
          },
        },
      };

      const keyValue = Object.entries(updatedChoices).find(([key]) => Number(key) === index);
      if (keyValue) {
        const result = { [keyValue[0]]: keyValue[1] };
        // Call handleAnswerChange to store the updated choices in the answer field
        handleAnswerChange(index, { answer: JSON.stringify(result) });
      } else {
        console.log('Key not found');
      }

      return updatedChoices; // Return the updated choices
    });
  };

  const handleAnswerChange = (index, updatedFields) => {
    // console.log(value)
    setQueAnswers((prevAnswers) =>
      prevAnswers.map((item, i) =>
        i === index ? { ...item, ...updatedFields } : item
      )
    );
  };
  const updateHandler = (e) => {
    e.preventDefault();
    setShowEditPopup(false);
    setLoadingPopup(true);
    const url = `${API_URL}update-question-answers`;
    console.log(queAnswers);
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        projID: project_id,
        expertID: expert_id,
        answers: queAnswers,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          setBackupData(
            backupData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.hasResponses = true;
              }
              return item;
            })
          );
          Swal.fire({
            icon: "success",
            title: "Answers updated to the database.",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };
  const containerStyle = {
    display: "flex",
    gap: "10px",
    marginLeft: "10px",
  };

  const buttonStyle = {
    border: "2px solid #ddd",
    borderRadius: "50px",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "14px",
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const buttonStyleSelected = {
    border: "2px solid #1a73e8",
    borderRadius: "50px",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "14px",
    color: "#1a73e8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const handleOnClick = (index, e) => {
    // const labels = document.querySelectorAll(".btnConf");
    // labels.forEach((label) => {
    //   label.style.borderColor = "#ddd";
    //   label.style.color = "#333";
    // });

    // e.target.parentElement.style.borderColor = "#1a73e8";
    // e.target.parentElement.style.color = "#1a73e8";

    handleAnswerChange(index, { answer: e.target.value });
  };

  useEffect(() => {
    if (data) {
      const expertID = data.expert.ID;
      const fetchExpertResponses = () => {
        const url = `${API_URL}get-expert-responses`;
        const data = {
          expertID: expertID,
          projectID: project_id,
        };
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setHasResponses(data.hasResponses);
          } else {
            console.log("No contact log found");
          }
        })
        .catch((err) => console.log(err));
      };
      fetchExpertResponses();
    }
  }, []);
  return (
    <>
      <button
        className="btn"
        style={{ width: "156px" }}
        onClick={() => handleOpenPopup()}
      >
        <i
          className={`${
            hasResponses ? "fa fa-comments" : "fa fa-comments-o"
          }  responses`}
          title="Click to View Responses"
        />{" "}
        Screening
      </button>
      {showEditPopup && (
        <div className="prjdetails-conEdit-popup-wrapper">
          <div
            className="tab-pane fade show prjdetails-conEdit-div"
            style={{ maxHeight: "70vh", overflowY: "auto", width: "1000px" }}
          >
            <h4 style={{ marginBottom: "20px", fontWeight: "bold" }}>
              Screening Questions
            </h4>
            <div className="row">
              {queAnswers &&
                queAnswers.map((row, index) => (
                  <div className="col-md-12">
                    <p style={{ marginBottom: "5px" }}>
                      {index + 1}. {row.question}
                    </p>
                    {row.answerType === "Open-Ended" ? (
                      <textarea
                        className="form-control"
                        placeholder="Give your answer..."
                        onChange={(e) => {
                          handleAnswerChange(index, { answer: e.target.value });
                        }}
                        value={row.answer ? row.answer : ""}
                      />
                    ) : row.answerType === "Yes/No" ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "10px",
                          }}
                        >
                          <input
                            type="radio"
                            name={`true-false-${index}`}
                            value="Yes"
                            style={{ marginRight: "10px" }}
                            checked={
                              row.answer.includes(";")
                                ? row.answer.split(";")[0] === "Yes"
                                : row.answer === "Yes"
                            }
                            onChange={(e) => {
                              const yesNo = e.target.value;
                              if (row.answer.includes(";")) {
                                const reasonYesNo = row.answer.split(";")[1];
                                handleAnswerChange(index, {
                                  answer: yesNo + ";" + reasonYesNo,
                                });
                              } else {
                                handleAnswerChange(index, {
                                  answer: e.target.value,
                                });
                              }
                            }}
                          />
                          Yes
                        </label>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "10px",
                          }}
                        >
                          <input
                            type="radio"
                            name={`true-false-${index}`}
                            value="No"
                            style={{ marginRight: "10px" }}
                            checked={
                              row.answer.includes(";")
                                ? row.answer.split(";")[0] === "No"
                                : row.answer === "No"
                            }
                            onChange={(e) => {
                              const yesNo = e.target.value;
                              if (row.answer.includes(";")) {
                                const reasonYesNo = row.answer.split(";")[1];
                                handleAnswerChange(index, {
                                  answer: yesNo + ";" + reasonYesNo,
                                });
                              } else {
                                handleAnswerChange(index, {
                                  answer: e.target.value,
                                });
                              }
                            }}
                          />
                          No
                        </label>
                        <textarea
                          placeholder="Give reasons"
                          name={`reasonYesNo-${index}`}
                          style={{
                            border: "none",
                            borderBottom: "1px solid black", // Set the bottom border
                            outline: "none",
                            width: "100%",
                            marginLeft: "50px",
                          }}
                          value={
                            row.answer.includes(";")
                              ? row.answer.split(";")[1]
                              : ""
                          }
                          onChange={(e) => {
                            const reasonYesNo = e.target.value;
                            if (row.answer.includes(";")) {
                              const yesNo = row.answer.split(";")[0];
                              handleAnswerChange(index, {
                                answer: yesNo + ";" + reasonYesNo,
                              });
                            } else {
                              handleAnswerChange(index, {
                                answer: row.answer + ";" + reasonYesNo,
                              });
                            }
                          }}
                        />
                      </div>
                    ) : row.answerType === "Confidence Level" ? (
                      <div style={containerStyle}>
                        <label
                          style={
                            row.answer == "High"
                              ? buttonStyleSelected
                              : buttonStyle
                          }
                          className="btnConf"
                        >
                          <input
                            type="radio"
                            name="confidence"
                            value="High"
                            // checked={row.answer === "High"}
                            style={{ display: "none" }}
                            onClick={(e) => handleOnClick(index, e)}
                          />
                          High
                        </label>
                        <label
                          style={
                            row.answer == "Medium"
                              ? buttonStyleSelected
                              : buttonStyle
                          }
                          className="btnConf"
                        >
                          <input
                            type="radio"
                            name="confidence"
                            value="Medium"
                            // checked={row.answer === "Medium"}
                            style={{ display: "none" }}
                            onClick={(e) => handleOnClick(index, e)}
                          />
                          Medium
                        </label>
                        <label
                          style={
                            row.answer == "Low"
                              ? buttonStyleSelected
                              : buttonStyle
                          }
                          className="btnConf"
                        >
                          <input
                            type="radio"
                            name="confidence"
                            value="Low"
                            // checked={row.answer === "Low"}
                            style={{ display: "none" }}
                            onClick={(e) => handleOnClick(index, e)}
                          />
                          Low
                        </label>
                        <label
                          style={
                            row.answer == "Not allowed to discuss"
                              ? buttonStyleSelected
                              : buttonStyle
                          }
                          className="btnConf"
                        >
                          <input
                            type="radio"
                            name="confidence"
                            value="Not allowed to discuss"
                            // checked={
                            //   row.answer === "Not allowed to discuss"
                            // }
                            style={{ display: "none" }}
                            onClick={(e) => handleOnClick(index, e)}
                          />
                          Not allowed to discuss
                        </label>
                      </div>
                    ) : row.answerType === "Matrix" ? (
                      <div>
                        <table
                          id="matrix-table"
                          style={{
                            width: "100%",
                            textAlign: "center",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  padding: "10px",
                                }}
                              ></th>
                              {row.choices.map((a, index) => (
                                <th
                                  key={index}
                                  style={{
                                    backgroundColor: "#f0f0f0",
                                    padding: "10px",
                                  }}
                                >
                                  {a || `Choice ${index + 1}`}
                                </th>
                              ))}
                              <th
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  padding: "10px",
                                }}
                              >
                                Reason
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {row.options.map((q, qIndex) => (
                              <tr key={qIndex}>
                                <td
                                  style={{
                                    backgroundColor: "#f0f0f0",
                                    padding: "10px",
                                  }}
                                >
                                  {q || `Option ${qIndex + 1}`}
                                </td>
                                {row.choices.map((_, aIndex) => (
                                  <td key={aIndex} style={{ padding: "10px" }}>
                                    <input
                                      type="radio"
                                      style={{
                                        height: "15px",
                                        width: "15px",
                                        transform: "scale(1)", // Reset scaling
                                        WebkitAppearance: "radio", // For Safari
                                        appearance: "radio",
                                      }}
                                      name={`question-${index}-${qIndex}`}
                                      value={`choice-${aIndex}`}
                                      checked={
                                        selectedChoices[index]?.[qIndex]
                                          ?.choice === aIndex
                                      } // Set checked if selected
                                      onChange={() =>
                                        handleSelectionChange(
                                          qIndex,
                                          aIndex,
                                          index
                                        )
                                      }
                                    />
                                  </td>
                                ))}
                                <td key={qIndex} style={{ padding: "10px" }}>
                                  <textarea
                                    // type="text"
                                    name={`reason-${qIndex}`}
                                    style={{
                                      border: "none",
                                      borderBottom: "1px solid black", // Set the bottom border
                                      outline: "none",
                                      width: "100%",
                                    }}
                                    value={
                                      selectedChoices[index]?.[qIndex]?.reason
                                    }
                                    onChange={(e) =>
                                      handleReasonChange(
                                        qIndex,
                                        e.target.value,
                                        index
                                      )
                                    }

                                    // value={`choice-${aIndex}`}
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        {row.options &&
                          row.options.map((option, optIndex) => (
                            <label
                              key={optIndex}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "10px",
                              }}
                            >
                              <input
                                type="checkbox"
                                name={`checkbox-${index}-${optIndex}`}
                                value={option}
                                checked={row.answer.includes(option)}
                                onChange={(e) => {
                                  const newAnswer = row.answer.includes(option)
                                    ? row.answer.filter((ans) => ans !== option)
                                    : [...row.answer, option];
                                  handleAnswerChange(index, {
                                    answer: newAnswer,
                                  });
                                }}
                              />
                              <span style={{ marginLeft: "10px" }}>
                                {option}
                              </span>
                            </label>
                          ))}
                      </div>
                    )}

                    <br />
                  </div>
                ))}
            </div>
            <div>
              <center>
                <button
                  type="button"
                  className="btn btn-light prjdetails-editCancel"
                  onClick={() => setShowEditPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={updateHandler}
                >
                  Update
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Updating data. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
      {fetchingData && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Fetching data. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
